
const port = window.location.protocol.includes('https') ? 4100 : 4000;

const server = {
  baseUrl: `${window.location.protocol}//${window.location.hostname}:${port}`,
  url: `${window.location.protocol}//${window.location.hostname}:${port}/api`,
};

export default server;